import { render, staticRenderFns } from "./OfficePropertiesForSale.vue?vue&type=template&id=3ef6d9e8"
import script from "./OfficePropertiesForSale.vue?vue&type=script&lang=ts"
export * from "./OfficePropertiesForSale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports